import type { ReceiptTemplate } from '../schema';

export const ralphsTemplate: ReceiptTemplate = {
  id: 'ralphs',
  name: 'Ralphs Receipt',
  brand: "Ralphs",
  description: 'Ralphs grocery store receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'ralphs-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/ralphs.png',
        logoData: '',
        logoWidth: 140,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'STORE #0847',
          '1200 DARK AVENUE',
          'LOS ANGELES, CA 90012',
          '(213) 555-0847',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ralphs-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: '01/04/2026 3:15 PM\nCASHIER: MIKE  LANE: 5',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'ralphs-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'ralphs-item-1', name: 'AVOCADOS 4CT', quantity: '1', price: '3.99'},
          { id: 'ralphs-item-2', name: 'ORGANIC MILK GAL', quantity: '1', price: '5.99'},
          { id: 'ralphs-item-3', name: 'SOURDOUGH BREAD', quantity: '1', price: '4.49'},
          { id: 'ralphs-item-4', name: 'CAGE FREE EGGS', quantity: '1', price: '6.99'},
          { id: 'ralphs-item-5', name: 'ROTISSERIE CHICKEN', quantity: '1', price: '8.99'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ralphs-savings',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '*** CLUB CARD SAVINGS: $3.47 ***',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: true,
      },
    },
    {
      id: 'ralphs-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'ralphs-subtotal', label: 'SUBTOTAL', value: '30.45', isBold: false, isLarge: false },
          { id: 'ralphs-savings', label: 'CLUB SAVINGS', value: '-3.47', isBold: false, isLarge: false },
          { id: 'ralphs-tax', label: 'TAX', value: '0.00', isBold: false, isLarge: false },
          { id: 'ralphs-total', label: 'TOTAL', value: '26.98', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'ralphs-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'ralphs-card', label: 'VISA', value: '************4847' },
          { id: 'ralphs-auth', label: 'AUTH', value: '847291' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'ralphs-fuel',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'FUEL POINTS EARNED: 26\nTOTAL FUEL POINTS: 1,284',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'ralphs-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '08470104261547',
        showValue: false,
        width: 1.5,
        height: 35,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ralphs-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'THANK YOU FOR SHOPPING\nFRESH FOR EVERYONE',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};
